(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-banner"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    console.group('[AnnouncementBanner][JS]');
    const modals = document.querySelectorAll('[class*="announcement-modal--"]');
    console.log('Found modals in DOM:', modals.length);

    if (!modals.length) {
      console.warn('No announcement modals rendered. This means Liquid did not output any .announcement-modal elements for this page.');
      console.groupEnd();
      return;
    }

    const DISMISS_WINDOW_MS = 5 * 60 * 1000;

    modals.forEach(function(modal) {
      const bannerId = modal.getAttribute('data-banner-id');
      const bannerTradeType = modal.getAttribute('data-trade-type') || '';
      const bannerTargetCompany = modal.getAttribute('data-target-company') || '';
      const dismissKey = 'announcement-dismissed-' + bannerId;

      console.group('[AnnouncementBanner][JS] Banner #' + bannerId);
      console.log('Data attributes:', {
        bannerId: bannerId,
        bannerTradeType: bannerTradeType,
        bannerTargetCompany: bannerTargetCompany
      });

      let dismissedRecently = false;

      try {
        const raw = localStorage.getItem(dismissKey);
        if (raw) {
          const lastDismissed = parseInt(raw, 10);
          const now = Date.now();
          const diff = now - lastDismissed;

          console.log('Previous dismiss timestamp:', {
            raw: raw,
            lastDismissed: lastDismissed,
            now: now,
            diffMs: diff
          });

          if (!isNaN(lastDismissed) && diff < DISMISS_WINDOW_MS) {
            dismissedRecently = true;
          }
        }
      } catch (error) {
        console.warn('[AnnouncementBanner][JS] Error reading from localStorage:', error);
      }

      if (dismissedRecently) {
        console.info(
          '[AnnouncementBanner][JS] Skipping banner because it was dismissed less than 5 minutes ago.',
          { bannerId: bannerId, dismissKey: dismissKey }
        );
        console.groupEnd();
        return;
      }

      modal.classList.add('is-active');
      console.log('Modal set to is-active.');

      const closeBtn = modal.querySelector('.announcement-modal__close');

      function closeHandler(event) {
        if (event) {
          event.preventDefault();
        }

        console.log('Closing banner and writing dismiss timestamp to localStorage', {
          bannerId: bannerId,
          dismissKey: dismissKey
        });

        if (document.startViewTransition) {
          document
            .startViewTransition(function() {
              modal.classList.remove('is-active');
            })
            .finished.then(function() {
              console.log('ViewTransition finished for banner close', bannerId);
            })
            .catch(function(error) {
              console.warn('ViewTransition error:', error);
            });
        } else {
          modal.classList.remove('is-active');
        }

        try {
          const now = Date.now();
          localStorage.setItem(dismissKey, String(now));
          console.log('[AnnouncementBanner][JS] localStorage updated:', {
            key: dismissKey,
            value: now
          });
        } catch (error) {
          console.error('[AnnouncementBanner][JS] Failed to write to localStorage:', error);
        }
      }

      if (closeBtn) {
        closeBtn.addEventListener('click', closeHandler);
        console.log('Close button handler attached.');
      } else {
        console.warn('No close button found inside modal.');
      }

      modal.addEventListener('click', function(event) {
        if (event.target === modal) {
          console.log('Overlay click detected; closing banner', bannerId);
          closeHandler(event);
        }
      });

      console.groupEnd();
    });

    console.groupEnd();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
